const cards = [
  {
    titulo: 'Nova sede',
    descricao: 'Para empresas montando um novo endereço ou operação.',
    icon: 'ri-building-line',
  },
  {
    titulo: 'Mudança',
    descricao: 'Para empresas que vão mudar de imóvel e precisam reimplantar o ambiente.',
    icon: 'ri-route-line',
  },
  {
    titulo: 'Expansão',
    descricao: 'Para equipes crescendo e necessitando novas estações, salas e áreas de apoio.',
    icon: 'ri-expand-left-right-line',
  },
  {
    titulo: 'Reforma',
    descricao: 'Para modernização de escritórios existentes.',
    icon: 'ri-brush-line',
  },
  {
    titulo: 'Projeto de arquiteto',
    descricao: 'Executamos e fornecemos soluções de acordo com a especificação do profissional.',
    icon: 'ri-draft-line',
  },
  {
    titulo: 'Implantação completa',
    descricao: 'Para empresas que querem centralizar diferentes fornecedores em uma única solução.',
    icon: 'ri-stack-line',
  },
];

export default function ParaQuemSection() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8">
        <div className="max-w-2xl mb-12 md:mb-16">
          <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
            Para quem é
          </p>
          <h2 className="text-foreground-950 text-[28px] md:text-[40px] font-semibold tracking-tight leading-tight">
            Em que momento sua empresa está?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card) => (
            <div
              key={card.titulo}
              className="bg-white border border-background-200/70 rounded-2xl p-7 md:p-8 hover:border-primary-200 transition-colors duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mb-6">
                <i className={`${card.icon} text-xl`}></i>
              </div>
              <h3 className="text-foreground-950 text-[18px] md:text-[20px] font-semibold tracking-tight mb-3">
                {card.titulo}
              </h3>
              <p className="text-foreground-500 text-[14px] md:text-[15px] leading-relaxed">
                {card.descricao}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}